import styled, { css } from 'styled-components';
import vars from './vars';

export const Button = styled.button<{
    primary?: boolean;
    iconOnly?: boolean;
    danger?: boolean;
    warning?: boolean;
}>`
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    border-radius: 6px;
    padding: 8px 12px;
    font: inherit;
    font-size: 1rem;
    font-weight: 400;
    gap: 8px;
    line-height: 1;

    color: ${(p) => {
        if (p.danger && p.primary) return '#fff';
        if (p.danger) return vars.dangerColor;
        if (p.warning && p.primary) return '#fff';
        if (p.warning) return vars.warningColor;
        return vars.foregroundColor;
    }};
    background-color: ${(p) => {
        if (p.danger && p.primary) return vars.dangerColor;
        if (p.warning && p.primary) return vars.warningColor;
        if (p.primary) return vars.primaryColor;
        return 'transparent';
    }};
    border: 1px solid
        ${(p) => {
            if (p.danger) return vars.dangerColor;
            if (p.warning) return vars.warningColor;
            return vars.foregroundColor;
        }};

    ${(p) =>
        p.iconOnly &&
        css`
            width: 36px;
            height: 36px;
            padding: 0;
            border-radius: 8px;
        `}

    &:not(:disabled):hover {
        text-decoration: none;

        ${(p) =>
            p.danger &&
            p.primary &&
            css`
                background-color: ${vars.dangerColorDark};
                color: #fff;
            `}

        ${(p) =>
            p.danger &&
            !p.primary &&
            css`
                background-color: ${vars.dangerTintSoft};
            `}

        ${(p) =>
            p.warning &&
            p.primary &&
            css`
                background-color: ${vars.warningColorDark};
                color: #fff;
            `}

        ${(p) =>
            p.warning &&
            !p.primary &&
            css`
                background-color: ${vars.warningTintSoft};
            `}

        ${(p) =>
            p.primary &&
            !p.danger &&
            !p.warning &&
            css`
                background-color: ${vars.primaryColorLight};
                color: ${vars.foregroundColor};
            `}

        ${(p) =>
            !p.primary &&
            !p.danger &&
            !p.warning &&
            css`
                background-color: ${vars.primaryColorLight};
                border-color: ${vars.foregroundColor};
            `}
    }

    &:disabled {
        opacity: 0.4;
        cursor: unset;
    }
`;
